'use client';
var getListWrapperAttributes = function(id) {
    return {
        "data-combobox-popover": true,
        "aria-labelledby": "" + id + "-label",
        id: "" + id + "-items",
        role: "listbox",
        tabIndex: -1
    };
};

export { getListWrapperAttributes };
